import { Feature } from 'react-feature'
import { connect } from 'react-redux'

import { IRootState } from '../../../common/reducers'
import { getFeaturesConfigSelector } from '../../../common/selectors/features'

interface IOwnProps {
  name?: string
  when?: (features: any) => boolean
}

interface IStateProps {
  config: any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  return {
    config: getFeaturesConfigSelector(state)
  }
}

const FeatureContainer = connect<IStateProps, unknown, IOwnProps, IRootState>(
  mapStateToProps
)(Feature)

FeatureContainer.displayName = 'FeatureContainer'

export default FeatureContainer
